import { ENV_CONFIG } from "./environment-config";

const environment = "local";

const app_config: any = ENV_CONFIG[environment];

export default app_config;
